<template>
    <transition name="fade">
        <div v-if="visible" class="question-wrap">
            <img v-if="question.type === 4 || question.type === 1" class="background" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_item4.png" />
            <img v-else-if="question.type === 6" class="background" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_item6.png" />
            <img v-else src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_item.png" />
            <div class="countdown" :class="time<=5 ? 'time-warning' : ''">{{ time > -1 ? time : ''}}</div>


            <!-- 질문 레이아웃 -->

            <!-- 3번 유형 질문 -->
            <v-layout v-if="question.type === 3" class="question kakao" column justify-center align-center>
                <div class="message">
                    <img :src="question.image" />
                </div>
                <v-layout class="text" align-center v-html="text(question)">
                </v-layout>
            </v-layout>

            <!-- 4번 유형 질문 -->
            <v-layout v-else-if="question.type === 4" class="question notice" column justify-center align-center>
                <img v-if="question.image" :src="question.image" />
                <div v-html="question.question"></div>
            </v-layout>

            <!-- 5번 유형 질문 -->
            <v-layout v-else-if="question.type === 5" class="question wedding" justify-start align-center>
                <span v-html="question.question"></span>
            </v-layout>

            <!-- 6번 유형 질문 -->
            <v-layout v-else-if="question.type === 6" class="question selection" justify-center align-center>
                <span v-html="question.question"></span>
            </v-layout>

            <!-- 나머지 유형 질문 -->
            <v-layout v-else class="question" justify-start align-center v-html="question.question">
            </v-layout>


            <!-- 옵션 레이아웃 -->

            <!-- 1번 유형 옵션 -->
            <v-layout v-if="question.type === 1" class="options image">
                <div class="option"
                     v-for="(option, index) in question.options"
                     :key="index"
                     @click="onSelect(index)"
                >
                    <img class="option-image default" :src="option.image" />
                    <img class="option-image hover" :src="option.image.replace('.png', '_hover.png')" />
                    <img class="indicator default" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_1.png" />
                    <img class="indicator hover" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                </div>
            </v-layout>

            <!-- 2번, 7번 유형 옵션 -->
            <v-layout v-else-if="question.type === 2 || question.type === 7" class="options text">
                <v-layout class="option"
                          column
                          v-for="(option, index) in question.options"
                          :key="index"
                          @click="onSelect(index)"
                >
                    <span>
                        <img class="indicator default" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_1.png" />
                        <img class="indicator hover" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                    </span>
                    <div class="text" v-html="option.option"></div>
                </v-layout>
            </v-layout>

            <!-- 3번 유형 -->
            <v-layout v-else-if="question.type === 3" class="options kakao">
                <v-layout class="option"
                          column
                          v-for="(option, index) in question.options"
                          :key="index"
                          @click="onSelect(index)"
                >
                    <span>
                        <img class="indicator default" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_1.png" />
                        <img class="indicator hover" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                    </span>
                    <div class="text" v-html="option.option"></div>
                </v-layout>
            </v-layout>

            <!-- 4번 유형 -->
            <v-layout v-else-if="question.type === 4" class="options notice">
                <v-layout class="option"
                          @click="onSelect(0)"
                          align-center justify-center
                >
                    <span>
                        <img class="indicator default" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                        <img class="indicator hover" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                    </span>
                    <div class="text" v-html="question.options[0].option"></div>
                </v-layout>
            </v-layout>

            <!-- 5번 유형 -->
            <v-layout v-else-if="question.type === 5" class="options wedding">
                <v-layout class="option"
                          column
                          v-for="(option, index) in question.options"
                          :key="index"
                          @click="onSelect(index)"
                >
                    <span>
                        <img class="indicator default" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_1.png" />
                        <img class="indicator hover" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator1_2.png" />
                    </span>
                    <div class="text" v-html="option.option"></div>
                </v-layout>
            </v-layout>

            <!-- 6번 유형 옵션 -->
            <v-layout v-else-if="question.type === 6" class="options selection">
                <v-layout class="option"
                          v-for="(option, index) in question.options"
                          :key="index"
                          @click="onSelect(index)"
                >
                    <span v-show="selectedOption !== 1">
                        <img class="indicator default" :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator6_${index === 0 ? 2 : 1}.png`" />
                        <img class="indicator hover" :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator6_${index === 0 ? 2 : 1}.png`" />
                    </span>
                    <span v-show="selectedOption === 1">
                        <img class="indicator default" :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator6_${index === 0 ? 1 : 2}.png`" />
                        <img class="indicator hover" :src="`https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/option_indicator6_${index === 0 ? 1 : 2}.png`" />
                    </span>
                    <div class="text" v-if="index === 0" :style="{
                        color: `${selectedOption === 0 ? '#292727' : '#ffffff'}`
                    }" v-html="option.option"></div>
                    <div class="text" v-if="index === 1" :style="{
                        color: `${selectedOption === 1 ? '#292727' : '#ffffff'}`
                    }" v-html="option.option"></div>
                </v-layout>
            </v-layout>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                time: -1,
                duration: 30,
                selectedOption: 0,
                st: null,
                lastId: 0,
            }
        },

        computed: {
            age() {
                let age

                if (!this.$gameData.ages || !this.$gameData.ages.length) return

                this.$gameData.ages.forEach(item => {
                    if (item.ages === this.$userData.age) {
                        age = item
                    }
                })

                return age
            },

            question() {
                if (!this.$gameData.questions) return {}

                const age = this.$userData.age
                const sequence = this.$userData.sequence

                const answers = this.$userData.answers

                const questions = []

                this.$gameData.questions.forEach(question => {
                    if (question.age === age) {
                        if (question.sequence === sequence) {
                            if (this.$gameData.surveys[question.id]) {
                                const survey = this.$gameData.surveys[question.id]
                                question.question = (survey.question || '').replace(/\[[^\]]+\]/g, '').replace(/\n/g, '<br />')
                                question.options.forEach((option, index) => {
                                    option.option = survey[`option${index+1}`].replace(/\[[^\]]+\]/g, '').replace(/\n/g, '<br />')
                                })
                                questions.push(question)
                            } else {
                                question.question = (question.question || '').replace(/\[[^\]]+\]/g, '').replace(/\n/g, '<br />')
                                question.options.forEach(option => {
                                    option.option = (option.option || '').replace(/\[[^\]]+\]/g, '').replace(/\n/g, '<br />')
                                })
                                questions.push(question)

                            }
                        }
                    }
                })

                if (questions.length === 1) {
                    if (answers[age] && answers[age][sequence]) return {}
                    this.$userData.question = questions[0]

                    // console.log('sequence', questions[0].managed_sequence)

                    // this.$userData.badgeCondition.forEach(cond => {
                    //     if (cond.sequence === questions[0].managed_sequence) {
                    //         console.log('option', cond.option)
                    //     }
                    // })
                    return questions[0]
                } else {
                    let question = null

                    let skip = false
                    questions.forEach((item, index) => {
                        if (question) return

                        let hasCondition = true
                        if (item.cond_baby === null && item.cond_married === null && item.cond_factor1 === null && item.cond_factor2 === null && item.cond_factor3 === null && item.cond_factor4 === null) {
                            hasCondition = false
                        }

                        let lastOptionId = answers[age] && answers[age][sequence]
                        if (lastOptionId === this.lastId && index === 0) {
                            return
                        }

                        item.options.forEach(option => {
                            if (option.id === lastOptionId) skip = true
                        })

                        if (skip) return


                        if (!hasCondition) {
                            question = item
                        } else if (item.cond_baby !== null && !!this.$userData.hasBaby === !!item.cond_baby) {
                            question = item
                        } else if (item.cond_married !== null && !!this.$userData.spouse === !!item.cond_married) {
                            question = item
                        } else if (item.cond_factor1 !== null) {
                            const operator = item.cond_factor1.substr(0, 1)
                            const value = parseInt(item.cond_factor1.substr(1, item.cond_factor1.length))
                            if (operator === '>' && this.$userData.factor1 >= value) question = item
                            else if (operator === '<' && this.$userData.factor1 < value) question = item
                        } else if (item.cond_factor2 !== null) {
                            const operator = item.cond_factor2.substr(0, 1)
                            const value = parseInt(item.cond_factor2.substr(1, item.cond_factor2.length))
                            if (operator === '>' && this.$userData.factor2 >= value) question = item
                            else if (operator === '<' && this.$userData.factor2 < value) question = item
                        } else if (item.cond_factor3 !== null) {
                            const operator = item.cond_factor3.substr(0, 1)
                            const value = parseInt(item.cond_factor3.substr(1, item.cond_factor3.length))
                            if (operator === '>' && this.$userData.factor3 >= value) question = item
                            else if (operator === '<' && this.$userData.factor3 < value) question = item
                        } else if (item.cond_factor4 !== null) {
                            const operator = item.cond_factor4.substr(0, 1)
                            const value = parseInt(item.cond_factor4.substr(1, item.cond_factor4.length))
                            if (operator === '>' && this.$userData.factor4 >= value) question = item
                            else if (operator === '<' && this.$userData.factor4 < value) question = item
                        }
                    })

                    if (skip) question = null

                    question = question || {}
                    this.$userData.question = question

                    // console.log('question', question.managed_sequence)
                    // this.$userData.badgeCondition.forEach(cond => {
                    //     if (cond.sequence === question.managed_sequence) {
                    //         console.log('option', cond.option)
                    //     }
                    // })

                    if (questions != {}) {
                        this.$playAudio(4)
                    }

                    return question
                }
            },

            message() {
                return question => {
                    if (question.type === 3 && question.question.indexOf('"') > -1) {
                        return question.question.replace(/^.*"([^"]+)".*$/, '$1')
                    }
                }
            },

            text() {
                return question => {
                    if (question.type === 3) {
                        return question.question.replace(/"[^"]+"/g, '')
                    }
                    return question.question
                }
            }

        },


        beforeDestroy() {
            $(document.body).off('keyup').off('mouseover', '.option')

            this.$eventBus.$off('SHOW_QUESTION')
            this.$eventBus.$off('CHANGE_AGE')

            if (this.st) {
                clearTimeout(this.st)
                this.st = null
            }
        },

        mounted() {

            this.$eventBus.$on('START_ENDING', _ => {
                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }
            })

            this.$eventBus.$on('SHOW_QUESTION', this.showQuestion)
            const self = this
            $(document.body).keyup(e => {
                if (this.time < 0) return

                let index = -1
                if (e.keyCode === 37) {
                    index = 0
                    this.$playAudio(15)
                } else if (e.keyCode === 39) {
                    index = 1
                    this.$playAudio(15)
                } else if (e.keyCode === 13) {
                    if (this.question.type === 4) {
                        this.onSelect(0)
                    } else {
                        index = $('.option').index($('.option.selected'))
                        if (index === -1) return
                        this.onSelect(index)
                    }
                }

                if (index > -1) {
                    if (this.question.type === 6) {
                        $('.background').attr('src', `https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_item6_${index + 1}.png`)
                        self.selectedOption = index
                    }
                    $('.option').removeClass('selected')
                    $('.option').eq(index).addClass('selected')
                }
            })
                .on('mouseover', '.option', e => {
                    if (this.time < 0) return

                    if (this.question.type === 6) {
                        const index = $('.option').index(e.currentTarget)
                        $('.background').attr('src', `https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_item6_${index + 1}.png`)
                        self.selectedOption = index
                    }

                    $('.option').removeClass('selected')
                    $(e.currentTarget).addClass('selected')

                    this.$playAudio(15)
                })

            this.$eventBus.$on('CHANGE_AGE', _ => {
                this.visible = false
                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }
            })

        },

        methods: {
            showQuestion() {
                this.visible = true
                this.startTimer()

                if (this.question.type === 5 && this.$userData.spouse) {
                    this.next(0)
                    return
                }

                this.$eventBus.$emit('SHOW_SPOUSE', this.question)

            },
            startTimer() {

                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }

                this.time = this.duration
                this.countdown()

                // this.st = setTimeout(_ => {
                //     this.time = this.duration
                //     this.countdown()
                // }, 2000)
            },

            countdown() {
                this.st = setTimeout(_ => {
                    if (this.time === 0) {
                        this.$eventBus.$emit('ADD_PENALTY')
                        this.st = null
                        clearTimeout(this.st)
                        this.st = null

                        if (this.$userData.penalty < 3) {
                            if (['9','9-1','21','21-1','59','59-1','65','65-1'].indexOf(this.question.managed_sequence) > -1) {
                                this.onSelect(0)
                            } else {
                                this.next(300)
                            }
                        }
                        return
                    } else if (this.time === 6) {
                        this.$playAudio(6)
                    }
                    this.time--
                    this.countdown()
                }, 1000)
            },

            onSelect(index) {
                if (!this.question || !this.question.options) return

                this.$stopAudio(6)
                this.$playAudio(2)

                const option = this.question.options[index]

                if (option.factor1) this.$userData.factor1 += option.factor1
                if (option.factor2) this.$userData.factor2 += option.factor2
                if (option.factor3) this.$userData.factor3 += option.factor3
                if (option.factor4) this.$userData.factor4 += option.factor4


                this.$eventBus.$emit('ON_OPTION_SELECT', this.question.managed_sequence, index + 1)

                let nextInterval = 300

                if (this.question.type === 5) {
                    if (index === 0) {
                        this.$userData.spouse = `${this.age.ages}-${this.question.sequence}`
                        this.$eventBus.$emit('GET_MARRIED')
                        this.visible = false
                        // nextInterval = 3000
                        nextInterval = this.question.id === 17 ? 300 : 3000
                    }
                }

                this.sendAnswer(option);

                // 40대 4번 문항 - 자녀
                if (this.$userData.age === 40 && this.question.managed_sequence === '36-1' && index === 0) {
                    this.$userData.hasBaby = true
                }

                if (!this.$userData.answers[this.$userData.age]) {
                    this.$set(this.$userData.answers, this.$userData.age, {})
                }
                this.$set(this.$userData.answers[this.$userData.age], this.$userData.sequence, option.id)

                this.lastId = option.id

                if (this.question.id) {
                    this.$userData.penalty %= 3
                    this.startTimer()
                    return
                }


                this.next(nextInterval)
            },

            next(interval) {

                this.$userData.penalty %= 3

                this.visible = false

                if (this.st) {
                    clearTimeout(this.st)
                    this.st = null
                }

                setTimeout(_ => {
                    if (this.$userData.sequence < this.age.items.length) {
                        this.$userData.sequence ++
                        this.$eventBus.$emit('START_MOVING')
                    } else {
                        const term = this.$gameData.isBadgeShown ? 3000 : 0
                        setTimeout(_ => {
                            this.$eventBus.$emit('CHANGE_AGE')
                        }, term)
                    }
                }, interval)
            },

            sendAnswer(option) {
                const params = {
                    id: this.question.id,
                    option_id: option.id,
                    round: this.$userData.round,
                }
                this.axios.post('/api/answer', params)
                    .then(response => {
                    })
            },

        },

    }
</script>

<style lang="scss" scoped>

    .question-wrap {
        position: absolute;
        right: 32.6px;
        /*top: 76.8px;*/
        bottom: 65px;
        word-break: keep-all;

        .countdown {
            position: absolute;
            width: 36px;
            height: 17px;
            top: 22.1px;
            left: 273.2px;
            font-size: 25px;
            font-family: "5x5 Pixel", sans-serif;
            text-align: center;
            line-height: 0.8;
            color: #000;

            &.time-warning {
                color: #fd0505;
            }
        }

        .question {
            position: absolute;
            width: 443.9px;
            height: 140px;
            top: 75px;
            left:68px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.69;
            font-family: GmarketSans, sans-serif;

            &.kakao {
                height: 165px;

                .message{
                    padding-bottom: 5px;
                    width: 336px;
                    position: relative;
                }
                .text {
                    font-size: 15px;
                }
            }

            &.notice {
                font-size: 26px;
                font-weight: 500;
                height: 300px;
                text-align: center;
            }

            &.selection {
                font-size: 26px;
                font-weight: 600;
                height: unset;
                top: 125px;

                span {
                    background-color: #292727;
                    padding: 10px 34px;
                }
            }

            &.wedding{
            }
        }
        .options {
            position: absolute;
            height: 162px;
            right: 68px;
            bottom: 33px;
            left: 68px;
            background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_options.png');
            background-repeat: no-repeat;

            .option {
                position: relative;
                cursor: pointer;
                padding-left: 2px;
                padding-top: 24px;
                width: 222px;

                .hover {
                    display: none;
                }

                .text {
                    margin-top: 15px;
                    width: 100%;
                    color: #ffffff;
                    font-family: GmarketSans, sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 1.69;
                    word-break: keep-all;
                }
            }

            .option+.option {

                &>span {
                    margin-left: 15px;
                }

                .text {
                    margin-left: 15px;
                }


                /*.indicator {*/
                /*    margin-left: 12px;*/
                /*}*/
            }

            .option.selected {
                .default {
                    display: none;

                }

                .hover {
                    display: block;
                }

                .text {
                    color: #f8ce48 !important;
                }
            }

            &.image {
                position: absolute;
                height: 194px;
                right: 68px;
                bottom: 40px;
                left: 68px;

                .option {
                    margin-top: 8px;
                    padding-top: 0;

                    .indicator {
                        position: absolute;
                        top: 11px;
                        left: 2px;
                    }

                    .option-image {
                        margin-top: 10px;
                    }

                    &+.option {
                        margin-left: 25px;

                        .option-image {
                            margin-left: -17px;
                        }
                    }
                }
            }

            &.text {
                height: 180px;
            }

            &.notice {
                position: absolute;
                height: 55px;
                right: 68px;
                bottom: 58px;
                left: 68px;
                background-image: none;

                .option {
                    padding: 0;

                    .text {
                        width: unset;
                        margin-top: 6px;
                        margin-left: 22px;
                        color: #f8ce48;
                        font-family: GmarketSans, sans-serif;
                        font-size: 28px;
                        line-height: 1.39;
                    }
                }
            }

            &.wedding{
                position: absolute;
                height: 180px;
                right: 68px;
                bottom: 33px;
                left: 68px;
                background-image: url('https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_options.png');
                background-repeat: no-repeat;

                .option {
                    padding-left: 2px;
                    padding-top: 27px;
                    width: 217px;

                    .text {
                        margin-top: 19px;
                        width: 170px;
                        color: #ffffff;
                        font-family: GmarketSans, sans-serif;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 1.69;
                        word-break: keep-all;
                    }
                }
            }

            &.selection {
                position: absolute;
                height: 209px;
                right: 68px;
                bottom: 33px;
                left: 68px;
                background-image: none;

                .option {
                    padding-left: 2px;
                    padding-top: 69px;
                    width: 217px;

                    .indicator {
                        span {
                            width: 41px;
                            position: absolute;
                        }
                    }

                    .text {
                        margin-left: 13px;
                        margin-top: -5px;
                        color: #ffffff;
                        font-family: GmarketSans, sans-serif;
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 1.73;
                        word-break: keep-all;
                    }

                    &.selected {

                        .text {
                            color: #292727 !important;
                        }
                    }
                }

            }
        }
    }

</style>
